import { TextTemplateProvider } from '../../../../hooks/use-text-templates/use-text-templates';
import { InboxContainer } from '../inbox-widget/styles/inbox-styles';
import CommsChatBox from './communications-chat-box';
import CommunicationsPanel from './communications-panel';
import { CommsPreviewFooter } from './styles/communcations-styles';

export interface Status {
  isUnread?: boolean;
  isArchived?: boolean;
  isSaved?: boolean;
}

interface CommuncationsWidgetProps {
  patientPhoneNumbers: string[];
  initialPhoneNumber: string;
  patientId?: number;
  locationId: number;
  timestamp?: number;
  initialMessage?: string;
}

export default function CommuncationsWidget({
  patientPhoneNumbers,
  initialPhoneNumber,
  patientId,
  locationId,
  timestamp,
  initialMessage
}: CommuncationsWidgetProps) {
  return (
    <InboxContainer className="inbox-container">
      <CommunicationsPanel timestamp={timestamp} />
      <CommsPreviewFooter className="comms-preview-footer">
        <TextTemplateProvider>
          <CommsChatBox
            phoneNumbers={patientPhoneNumbers}
            locationId={locationId}
            patientId={patientId}
            initialPhoneNumber={initialPhoneNumber}
            initialMessage={initialMessage}
          />
        </TextTemplateProvider>
      </CommsPreviewFooter>
    </InboxContainer>
  );
}
